import UnknownIcon from '@clearkit/icons/glyphs/Unknown';
import { CKTooltip } from '@clearkit/react';

import StatusIcon from '~/components/audiences/StatusIcon';
import { audienceHealth, audienceStatuses } from '~/lib/audiences';

import HealthIndicator from './base';

export default function AudiencesHealthIndicator({
  audience,
  className,
  variant,
  justifyTooltip,
}) {
  const health = audienceHealth(audience.externalEstimatedSize);
  let indicator;

  if (audience.status === audienceStatuses.initializing) {
    indicator = <StatusIcon audience={audience} />;
  } else if (audience.status === audienceStatuses.inactive) {
    indicator = <StatusIcon audience={audience} />;
  } else if (health === null) {
    indicator = <UnknownIcon className="text-gray-400" />;
  } else {
    indicator = (
      <HealthIndicator
        health={health}
        variant={variant}
        justifyTooltip={justifyTooltip}
      />
    );
  }

  return (
    <CKTooltip
      unstable_portal
      tooltip={<AudienceHealthTooltip audience={audience} />}
      className={classnames('whitespace-normal', { 'ml-1': !justifyTooltip })}
      arrowPlacement={justifyTooltip ? 'bottom' : 'bottom-end'}
      options={
        justifyTooltip ? { placement: 'top' } : { placement: 'top-end' }
      }>
      <div className={className}>{indicator}</div>
    </CKTooltip>
  );
}

const AudienceHealthTooltip = ({
  audience: { externalEstimatedSize, status },
}) => {
  const health = audienceHealth(externalEstimatedSize);

  if (status === audienceStatuses.initializing)
    return <>Audience is initializing</>;
  if (status === audienceStatuses.inactive) return <>Audience is inactive</>;
  if (health === null)
    return <>Metrics aren't supported for this audience type</>;
  if (externalEstimatedSize === 0) return <>No matches</>;
  if (externalEstimatedSize <= 2_000)
    return (
      <>
        Tiny audience size <br /> 0K-2K
      </>
    );
  if (externalEstimatedSize <= 10_000)
    return (
      <>
        Small audience size <br /> 2K-10K
      </>
    );
  if (externalEstimatedSize <= 20_000)
    return (
      <>
        Medium audience size <br /> 10K-20K
      </>
    );
  if (externalEstimatedSize <= 200_000)
    return (
      <>
        Normal audience size <br /> 20k-200K
      </>
    );
  if (externalEstimatedSize > 200_000)
    return (
      <>
        Extra-large audience size <br /> 200K+
      </>
    );

  return null;
};

AudiencesHealthIndicator.propTypes = {
  classes: PropTypes.object.isRequired,
  audience: PropTypes.object.isRequired,
};
